/**
 * Tournament Rules Tab (campaign variant)
 * Composes the shared CampaignRulesTab shell with the tournament-specific sections
 */

import { memo, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { RulesTab as CampaignRulesTab } from '../../../../shared/tabs';
import { TournamentRulesContent } from './TournamentRulesContent';

const RulesTab: FC = () => {
  const { t } = useTranslation();

  return (
    <CampaignRulesTab
      Content={TournamentRulesContent}
      termsFallback={t('tournaments.default_terms', 'Standard tournament terms and conditions apply.')}
    />
  );
};

export default memo(RulesTab);
